module.exports = __webpack_public_path__ + "static/media/logo-cid.18652236.png";